export enum MapOverlayTypes {
  Ground_Overlay = 1,
  Tiles = 2
};
